fragment ReplyTaskFragment on ReplyTask {

    id
    title
    status

    assigned_to_id

    assignedTo {
        ...AdminFragment
    }

    sequence_number

    threads {
        ...ReplyTaskThreadFragment
    }

    firstThread {
        ...ReplyTaskThreadFragment
    }

    created_at
    updated_at

}